export default "__VITE_ASSET__DHEnhsBw__"